import { PATH_BACKEND } from 'configs/routes/pathsBackend';
import ModelActionsService from 'services/storageModelActions/ModelActionsService';
import IServerOldActionActionsService from './IServerOldActionActionsService';
import { GetOldActionListRequestDTO, ServerOldActionRequestDTO, ServerOldActionResponseDTO, StartOldActionRequestDTO } from 'typings/dto/serverOldAction';

export default class ServerOldActionActionsServiceImpl
  extends ModelActionsService<ServerOldAction, ServerOldActionRequestDTO, ServerOldActionResponseDTO>
  implements IServerOldActionActionsService {
  public getList = (dto: GetOldActionListRequestDTO) => {
    return super.getList(dto);
  };

  public getOrderActionById = (actionId: string, orderId: string) => {
    return this.getById(actionId, PATH_BACKEND.action.root, { orderId });
  };

  /** @throws `BackendResponseError` */
  public start = async ({ actionId, orderId, ...restDTO }: StartOldActionRequestDTO) => {
    const path = PATH_BACKEND.action.start + '/' + actionId + '/order/' + orderId;
    return this.entityApiService.postWithCredentials<void>(path, restDTO, false);
  };
}
